import PropTypes from "prop-types";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {Button, Tooltip, Typography} from "@material-ui/core";
import {formatMissingData} from "../../../utils/formatDataUtils";
import Clamp from "react-multiline-clamp";
import React, {useState} from "react";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import {CustomTable, useTokenOptionsTableStyles} from "./TokenOptionsTableStyles";
import TokenDescriptionDialog from "./token-description-dialog/TokenDescriptionDialog";
import EmptyRow from "../../../../components/ui/tables/rows/empty-row/EmptyRow";
import HelpIcon from "@material-ui/icons/Help";
import ChangeExtraGbStatusDialog from "./change-extra-gb-status-dialog/ChangeExtraGbStatusDialog";

const TokenOptionsTable = (props) => {
    const classes = useTokenOptionsTableStyles()
    const [openFullDescDialog, setOpenFullDescDialog] = useState(false)
    const [clickedTokenDetails, setClickedTokenDetails] = useState({})
    const [openChangeExtraGb, setOpenChangeExtraGb] = useState(false)
    const handleClickDettagliButton = (token) => {
        setClickedTokenDetails(token)
        setOpenFullDescDialog(true)
    }

    const handleChangeExtraGbClick = (token) => {
        setClickedTokenDetails(token)
        setOpenChangeExtraGb(true)
    }

    const getShowMoreElement = (token) => {
        return (
            <Button size={"small"}
                    variant={"text"}
                    color={"secondary"}
                    onClick={() => handleClickDettagliButton(token)}>
                Vedi i dettagli
            </Button>
        )
    }

    // TODO: optimize
    const getTableHeader = (
        <TableRow>
            <TableCell width={"12%"}/>
            <TableCell align="left"
                       width={"68%"}>
                <Typography variant={"overline"}
                            color={"textSecondary"}>
                    Contenuto
                </Typography>
            </TableCell>
            <TableCell align="left" width={"20%"}>
                <Typography variant={"overline"}
                            color={"textSecondary"}>
                    Costo
                </Typography>
            </TableCell>
        </TableRow>
    )

    const getRowContent = (token, index) => {
        return (
            <TableRow key={"opzioni-card-row-" + index}>
                <TableCell className={classes.contentCell}>
                    <Typography variant={"subtitle2"}>
                        {formatMissingData(token.optionName)}
                        {token.displayTooltip ? <Tooltip arrow
                                                         placement="top"
                                                         style={{marginLeft: "0.5em"}}
                                                         title={token.tooltipText}>
                            <HelpIcon color="primary" fontSize="small"/>
                        </Tooltip> : null}
                    </Typography>
                </TableCell>
                <TableCell className={classes.contentCell}>
                    <Clamp
                        lines={3}
                        withToggle
                        showMoreElement={() => getShowMoreElement(token)}>
                        <Typography variant={"body2"}>
                            {formatMissingData(token.description)}
                        </Typography>
                    </Clamp>
                </TableCell>
                <TableCell className={classes.contentCell}>
                    <Typography variant={"h6"}>
                        {formatMissingData(token.monthlyPrice)}
                    </Typography>
                    {props.isGettone && token.optionName.includes("Extra GB") ?
                        <Button color="primary" onClick={() => handleChangeExtraGbClick(token)}
                                className={classes.modificaStatoButton}>Modifica dello stato</Button> : null}
                </TableCell>
            </TableRow>
        )
    }

    return (
        <>
            <TableContainer>
                <CustomTable>
                    <TableHead>
                        {getTableHeader}
                    </TableHead>
                    <TableBody>
                        {props.data && props.data.length ? props.data.map((row, index) => getRowContent(row, index)) :
                            <EmptyRow colSpan={3} text={"dato"}/>}
                    </TableBody>
                </CustomTable>
            </TableContainer>

            {openFullDescDialog ?
                <TokenDescriptionDialog open={openFullDescDialog}
                                        description={clickedTokenDetails.description}
                                        title={clickedTokenDetails.optionName}
                                        handleDialogClose={() => setOpenFullDescDialog(false)}/>
                : null}

            {openChangeExtraGb ? <ChangeExtraGbStatusDialog open={openChangeExtraGb}
                                                            handleDialogClose={() => setOpenChangeExtraGb(false)}
                                                            token={clickedTokenDetails}
                                                            sim={props.sim}/> : null}
        </>
    )
}

TokenOptionsTable.propTypes = {
    data: PropTypes.array.isRequired,
    sim: PropTypes.shape({
        iccId: PropTypes.string.isRequired,
        msisdn: PropTypes.string.isRequired
    }).isRequired,
    isGettone: PropTypes.bool
}

TokenOptionsTable.defaultProps = {
    isGettone: false
}

export default TokenOptionsTable;
